webpackJsonp([172411548396689],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactstrap = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImpressumPage = function ImpressumPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Impressum'
	    }),
	    _react2.default.createElement(
	      'section',
	      { className: 'bg-light' },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'align-items-center pt-5 pt-lg-7' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Impressum ',
	              _react2.default.createElement(
	                'small',
	                { className: 'text-muted' },
	                'gem. \xA75 E-Commerce Gesetz.'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'pt-5 pt-lg-7' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: '6', md: '4' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'text-uppercase' },
	              'Adresse'
	            ),
	            _react2.default.createElement(
	              'address',
	              null,
	              'Thomas Schmidleithner, BSc',
	              _react2.default.createElement('br', null),
	              'Grolzham 2D',
	              _react2.default.createElement('br', null),
	              '4680 Weibern',
	              _react2.default.createElement('br', null),
	              '\xD6sterreich'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { xs: '6', md: '4' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'text-uppercase' },
	              'Telefon'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '+43 664 14 555 90'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '4' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'text-uppercase' },
	              'Email'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'mailto:thomas@schmidleithner.at' },
	                'thomas@schmidleithner.at'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'pb-5 pb-lg-7 align-items-center' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '4', className: 'mt-5' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'text-uppercase' },
	              'UID-Nummer'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'ATU72845228'
	            )
	          ),
	          _react2.default.createElement(
	            _reactstrap.Col,
	            { md: '6', className: 'mt-5' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Mitglied der Wirtschaftskammer Ober\xF6sterreich, Fachgruppe Unternehmensberatung, Buchhaltung und Informationstechnologie'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'border-top' },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          { className: 'py-7' },
	          _react2.default.createElement(
	            _reactstrap.Col,
	            null,
	            _react2.default.createElement(
	              'h2',
	              { className: 'mb-3' },
	              'Rechtlicher Hinweis.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Die Inhalte dieser Website werden st\xE4ndig aktualisiert und gepr\xFCft. Trotz aller Sorgfalt kann keinerlei Gew\xE4hr f\xFCr die Aktualit\xE4t, Vollst\xE4ndigkeit und Richtigkeit der auf dieser Webseite bereitgestellten Informationen \xFCbernommen werden. Eine Haftung oder Garantie hierf\xFCr kann daher nicht \xFCbernommen werden. Gleiches gilt auch f\xFCr alle anderen Webseiten, auf die mittels eines Hyperlinks von dieser Webseite verwiesen wird. F\xFCr den Inhalt der Webseiten, die aufgrund einer solchen Verbindung erreicht werden k\xF6nnen, sind wir nicht verantwortlich. Daher erkl\xE4ren wir ausdr\xFCcklich, dass zum Zeitpunkt der Linksetzung die verlinkte Webseite frei von illegalen Inhalten war.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Wir behalten uns das Recht vor, Erg\xE4nzungen, \xC4nderungen oder L\xF6schungen der auf dieser Webseite bereitgestellten Informationen jederzeit und ohne Ank\xFCndigung vorzunehmen oder die Ver\xF6ffentlichung zeitweise oder endg\xFCltig einzustellen.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Inhalte und Struktur der Webseite serverless.at sind urheberrechtlich gesch\xFCtzt. Die Vervielf\xE4ltigung von Informationen oder Daten, insbesondere die Verwendung von Texten, Textteilen, Soundfiles oder Bildmaterial bedarf der vorherigen schriftlichen Zustimmung des Herausgebers.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ImpressumPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-impressum-js-960fbf3f83baf464d034.js